import {
    ClickMix,
    Comandas,
    Ifood,
    LojaIntegrada,
    NuvemShop,
    OSuper,
    PidoMe,
    S2Pay,
    SiteMercado,
    SupermercadosNow
} from '../../components/sistemas-integracao/sistemas-integracao'
import Ellipse1 from '../../components/public/mobile/ellipse1169617-u9w9.svg'
import Ellipse2 from '../../components/public/mobile/ellipse1169618-ftubk.svg'
import Back1 from '../../components/public/background/Background Mobile/1.png'
import Back2 from '../../components/public/background/Background Mobile/2.png'
import Back3 from '../../components/public/background/Background Mobile/3.png'
import BackFiguras1 from '../../components/public/background/Background Mobile/Figuras/1.png'
import BackFiguras2 from '../../components/public/background/Background Mobile/Figuras/2.png'
import BackFiguras3 from '../../components/public/background/Background Mobile/Figuras/3.png'
import BackFiguras4 from '../../components/public/background/Background Mobile/Figuras/4.png'
import BackFiguras5 from '../../components/public/background/Background Mobile/Figuras/5.png'
import BackFiguras6 from '../../components/public/background/Background Mobile/Figuras/6.png'
import BackFiguras7 from '../../components/public/background/Background Mobile/Figuras/7.png'
import BackFiguras8 from '../../components/public/background/Background Mobile/Figuras/8.png'
import image1414536 from '../../components/public/park/image1414536-q97-200w.png'
import Image1 from '../../components/public/imagens sistema/Mobile/Image1.png'
import Image2 from '../../components/public/imagens sistema/Mobile/Image2.png'
import Image3 from '../../components/public/imagens sistema/Mobile/Image3.png'
import Image4 from '../../components/public/imagens sistema/Mobile/Image4.png'
import './autoComMobile.css'
import './background.css'
import { IconsGrande, IconsPequeno } from '../../components/icons-sistema/icons-sistema'
import { useKeenSlider } from 'keen-slider/react'
import Venda from '../../components/public/pdv/group480879-ci.svg'
import Controle from '../../components/public/icons/Restantes/Controle.svg'
import Receba from '../../components/public/icons/Restantes/Receba.svg'
import CupomNfce from '../../components/public/pdv/cupom-sat-nfe.svg'
import AutoAtendimento from '../../components/public/icons/Restantes/AutoAtendimento.svg'
import WhiteLabel from '../../components/public/pdv/white-label.png'
import SuporteTecnico from '../../components/public/pdv/suporte-tecnico.png'
import Celular from '../../components/public/mobile/Celular.png'
import CelularCompleto from '../../components/public/mobile/Celular completo.png'
import S2PayMaq from '../../components/public/mobile/imagem s2pay maq.png'
import { Link } from 'react-router-dom'
import { QrCode } from '../../components/qrcode/qrcode'
import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider'
import { useHistory } from 'react-router'
import { Footer } from '../../components/footer/footer'
import Helmet from 'react-helmet'
import { useState } from 'react'
import { Box, Button, Divider, IconButton, List, ListItem, ListItemIcon, SwipeableDrawer, Toolbar, Typography, useTheme } from '@material-ui/core'
import { useStyles } from './mobile-style'
import clsx from 'clsx';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from '@material-ui/icons/Menu';
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage'

export const SaurusMobile = () => {
    const { DefinirRota, IsValidSession, Logout } = useSessaoAtual()
    const classes = useStyles()
    const theme = useTheme();
    const history = useHistory()
    const [open, setOpen] = useState(false);
    const { getRegister } = useBaixasStorage();
    const user = getRegister(BaixasStorageKeys.data)

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpen(false);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    DefinirRota('/saurus-mobile')
    if (!IsValidSession) history.push('/')

    const [refCallback] = useKeenSlider(
        {
            slides: { perView: 'auto', spacing: 10 },
        },
        [
            // add plugins here
        ]
    )

    return (
        <>
            {user.id ?
                <>
                    <Toolbar className={classes.appBar}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, open && classes.hide)}
                        >
                            <MenuIcon className={classes.menuButton} />
                            <Typography style={{ fontSize: '17px', padding: '0 15px' }} variant="h4">
                                Saurus Mobile
                            </Typography>
                        </IconButton>
                        {/* <QrCode backColor="#386D9F" /> */}
                    </Toolbar>
                    <SwipeableDrawer
                        className={classes.drawer}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        open={open}
                        anchor={'left'}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <div className={classes.drawerHeader}>
                            <Typography style={{ fontSize: '17px', padding: '0px 85px 0 0' }} variant="h4">
                                Saurus Mobile
                            </Typography>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>
                        </div>
                        <Divider />
                        <div style={{ backgroundColor: '#fafafa' }}>
                            <List >
                                <ListItem button className={classes.listFilho}>
                                    <ListItemIcon onClick={() => history.push('/cadastrar')}>
                                        Cadastrar-se
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            <Divider />
                            <ListItem button className={classes.list} >
                                <ListItemIcon onClick={() => history.push('/representante')}>
                                    Representante
                                </ListItemIcon>
                            </ListItem>
                        </div>
                        <Box flexGrow={1} bgcolor='#fafafa' />  {/* jogou o sair para baixo */}
                        <Divider classes={{ root: classes.divider }} />
                        <ListItem button className={classes.list} >
                            <ListItemIcon onClick={() => history.push('/login')}>
                                Sair
                            </ListItemIcon>
                        </ListItem>
                    </SwipeableDrawer>
                </>

                :
                <>
                    <div style={{ padding: '8px 8px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' style={{ backgroundColor: '#6D2988', zIndex: 1, color: '#fff' }} onClick={() => history.push('/login')}>Logar</Button>
                        <Button variant='outlined' style={{ backgroundColor: '#6D2988', zIndex: 1, color: '#fff' }} onClick={() => history.push('/representante')}>Representante</Button>
                    </div>
                </>
            }
            <div className="saurusMobilePage">
                <Helmet>
                    <title>Saurus Mobile - Saurus AutoCom</title>
                    <meta content="#6D2988" name="theme-color" />
                </Helmet>
                <div className="d-none-pc">
                    <img src={Back1} alt="" className="background1" />
                    <img src={Back2} alt="" className="background2" />
                    <img src={Back3} alt="" className="background3" />
                    <img src={BackFiguras1} alt="" className="background-figuras1" />
                    <img src={BackFiguras2} alt="" className="background-figuras2" />
                    <img src={BackFiguras3} alt="" className="background-figuras3" />
                    <img src={BackFiguras4} alt="" className="background-figuras4" />
                    <img src={BackFiguras5} alt="" className="background-figuras5" />
                    <img src={BackFiguras6} alt="" className="background-figuras6" />
                    <img src={BackFiguras7} alt="" className="background-figuras7" />
                    <img src={BackFiguras8} alt="" className="background-figuras8" />
                </div>
                <div className="d-none-celular">
                    <img src={Back1} alt="" className="background-desk1" />
                    <img src={Back2} alt="" className="background-desk2" />
                    <img src={Back3} alt="" className="background-desk3" />
                    <img src={BackFiguras1} alt="" className="background-figuras-desk1" />
                    <img src={BackFiguras1} alt="" className="background-figuras-desk1-1" />
                    <img src={BackFiguras1} alt="" className="background-figuras-desk1-2" />
                    <img src={BackFiguras2} alt="" className="background-figuras-desk2" />
                    <img src={BackFiguras2} alt="" className="background-figuras-desk2-1" />
                    <img src={BackFiguras3} alt="" className="background-figuras-desk3" />
                    <img src={BackFiguras4} alt="" className="background-figuras-desk4" />
                    <img src={BackFiguras5} alt="" className="background-figuras-desk5" />
                    <img src={BackFiguras6} alt="" className="background-figuras-desk6" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-1" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-2" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-3" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-4" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-5" />
                    <img src={BackFiguras7} alt="" className="background-figuras-desk7-6" />
                    <img src={BackFiguras8} alt="" className="background-figuras-desk8" />
                    <img src={BackFiguras8} alt="" className="background-figuras-desk8-1" />
                    <img src={BackFiguras8} alt="" className="background-figuras-desk8-2" />
                </div>
                <div className="p-d-v1430-container">
                    <div className="p-d-v1430-p-d-v1430">
                    {user.id ?
                            <div className="p-d-v1430-group11911453" >
                            </div>
                            :
                            <div className="saurusMobilePage .p-d-v1430-group45218" >
                            </div>
                        }
                        <div className="sliders">
                            <div id="my-keen-slider" ref={refCallback} className="keen-slider">
                                <div className="keen-slider__slide slide-servicos-grande">
                                    <img src={IconsGrande().MobileGrande} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/touchone">
                                        <img src={IconsPequeno().TouchOnePequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-pdv">
                                        <img src={IconsPequeno().PDVPequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-v4">
                                        <img src={IconsPequeno().V4Pequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <div className='d-none-celular pt-5' />
                                    <div className="p-d-v1430-conheao-saurus-p-d-v15174">
                                        <span className="p-d-v1430-text02">
                                            <span className="p-d-v1430-text03">Conheça o</span>
                                            <div className="text-saurus-pdv">
                                                <span className="p-d-v1430-text04">
                                                    <span>SAURUS</span>
                                                </span>
                                                <span className="p-d-v1430-text08">MOBILE</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="content-sistema-versatil">
                                        <span className="p-d-v1430-text38">
                                            <span className="p-d-v1430-text40">PDV Móvel. </span>
                                            <span className="p-d-v1430-text39">Simples de operar. Registra </span>
                                            <span className="p-d-v1430-text40">em </span>
                                            <span className="p-d-v1430-text39">e a retaguarda </span>
                                            <span className="p-d-v1430-text40">qualquer momento </span>
                                            <span className="p-d-v1430-text39">e de qualquer lugar. Se integra tanto com a </span>
                                            <span className="p-d-v1430-text40">retaguarda web </span>
                                            <span className="p-d-v1430-text39">quanto com a </span>
                                            <span className="p-d-v1430-text40">retaguarda local.</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-none-celular">
                                    <div className="d-flex justify-content-center">
                                        <img src={S2PayMaq} className="s2pay-maq" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container icons-content">
                            <div className="row">
                                <div className="col-4 col-lg">
                                    <div className="p-d-v1430-frentedecaixa11839">
                                        <div className="imagem70">
                                            <img src={Venda} alt="Group480879" className="p-d-v1430-image07" />
                                        </div>
                                        <span className="p-d-v1430-text09">
                                            <span className="p-d-v1430-text10">VENDA</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-4 col-lg">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={Controle} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">CONTROLE</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-4 col-lg">
                                    <div className="p-d-v1430-cupom-s-a-t-n-f-ce11850">
                                        <img src={Receba} alt="Group4721012" className="p-d-v1430-image22" />
                                        <span className="p-d-v1430-text33">
                                            <span className="p-d-v1430-text34">
                                                <span>RECEBA</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-lg">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={CupomNfce} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">CUPOM NFC-E</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-lg">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={AutoAtendimento} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">AUTO-ATENDIMENTO</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="my-keen-sliderr" ref={refCallback} className="keen-slider container">
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image1} rel="noreferrer" target="_blank">
                                    <img src={Image1} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image2} rel="noreferrer" target="_blank">
                                    <img src={Image2} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image3} rel="noreferrer" target="_blank">
                                    <img src={Image3} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image4} rel="noreferrer" target="_blank">
                                    <img src={Image4} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container d-none-pc">
                            <div className="p-d-v1430-text48">
                                <span>
                                    <span>
                                        <span className="p-d-v1430-text49">O caixa que vai</span>
                                        <br />
                                    </span>
                                    <span className="p-d-v1430-text54">até o cliente</span>
                                </span>
                            </div>
                            <span className="p-d-v1430-text87">
                                <span className="p-d-v1430-text88">Roda em </span>
                                <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">diversos dispositivos</span>, </span>
                                <span className="p-d-v1430-text90">inclusive em </span>
                                <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">máquinas de cartão </span>.</span><br />
                                <span className="p-d-v1430-text90">Disponível também em versão </span>
                                <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">auto-atendimento</span>.</span><br />
                            </span>
                        </div>

                        <div className="pdv-maquininha d-none-pc">
                            <img src={Celular} alt="Group4721050" className="p-d-v1430-image21" />
                        </div>

                        <div className="container container-apps-integracoes margin-bottom-1rem">
                            <div className="row">
                                <div className="col-lg-5 col-12 apps-integracoes">
                                    <span className="p-d-v1430-text55">
                                        <span className="p-d-v1430-text56">Apps e Integrações</span>
                                    </span>
                                    <hr className="hr-colorido" />
                                    <div className=" images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg-3">
                                                <img src={Comandas()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-3">
                                                <img src={S2Pay()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-bottom-1rem">
                                        <span className="p-d-v1430-text55">
                                            <span className="p-d-v1430-text58">Integrações</span>
                                        </span>
                                        <hr className="hr-colorido" />
                                    </div>
                                    <div className=" images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg">
                                                <img src={LojaIntegrada()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={Ifood()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={NuvemShop()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={SiteMercado()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={ClickMix()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={SupermercadosNow()} alt="Rectangle8658211807"
                                                    className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={OSuper()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg">
                                                <img src={PidoMe()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 d-none-celular">
                                    <div className="ms-5">
                                        <div className="p-d-v1430-text48">
                                            <span>
                                                <span>
                                                    <span className="p-d-v1430-text49">O caixa que vai</span>
                                                    <br />
                                                </span>
                                                <span className="p-d-v1430-text54">até o cliente</span>
                                            </span>
                                        </div>
                                        <span className="p-d-v1430-text87">
                                            <span className="p-d-v1430-text88">Roda em </span>
                                            <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">diversos dispositivos</span>, </span>
                                            <span className="p-d-v1430-text90">inclusive em </span>
                                            <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">máquinas de cartão </span>.</span><br />
                                            <span className="p-d-v1430-text90">Disponível também em versão </span>
                                            <span className="p-d-v1430-text88"><span className="p-d-v1430-text89">auto-atendimento</span>.</span><br />
                                        </span>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-lg-6">
                                            <img src={CelularCompleto} className="celular-completo" alt="" />
                                        </div>
                                        <div className="col-lg-6 d-flex align-items-center">
                                            <div>
                                                <div className="d-flex mb-5">
                                                    <img src={WhiteLabel} alt="" />
                                                    <div>
                                                        <span className="white-suporte">WHITE LABEL</span>
                                                        <br />
                                                        <span className="white-suporte-texto">
                                                            O <span>SAURUS PDV</span> também
                                                            permite customização para
                                                            que o sistema tenha a
                                                            identidade da sua marca!
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <img src={SuporteTecnico} alt="" />
                                                    <div className="ms-3">
                                                        <span className="white-suporte">SUPORTE TÉCNICO</span>
                                                        <br />
                                                        <span className="white-suporte-texto">
                                                            Equipe <span>especializada</span>
                                                            no atendimento à
                                                            revendedores.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" pb-3">
                                            <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href="https://saurus.blob.core.windows.net/autocom/MOBILE.pdf" target="_blank">
                                                <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                                <span className="p-d-v1430-text60">PDF</span>
                                            </a>
                                            <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/saurus-mobile/">
                                                <span className="p-d-v1430-text62">Mais informações</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container d-none-pc pb-3">
                            <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href="https://saurus.blob.core.windows.net/autocom/MOBILE.pdf" target="_blank">
                                <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                <span className="p-d-v1430-text60">PDF</span>
                            </a>
                            <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/saurus-mobile/" target="_blank" rel="noreferrer noopener">
                                <span className="p-d-v1430-text62">Mais informações</span>
                            </a>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}